// Helper to combine class names.  It can take booleans as well
// ie createClassName(['foo', false && 'goo', true && 'bar']) will return 'foo bar'
export const createClassName = (classes: Array<string | false | undefined>) =>
  classes.filter((cla) => Boolean(cla)).join(' ')
